import {useState} from 'react';
const REGISTERS=[
 ['entities','Daftar entitas',['id']],
 ['cost_centers','Daftar pusat biaya',['id','entity_id']],
 ['source_references','Daftar referensi dokumen sumber',['source_module','source_number','entity_id']],
 ['fiscal_periods','Kalender fiskal',['fiscal_year','period','start','end']],
];
const empty=()=>Object.fromEntries([['basis',''],...REGISTERS.map(([key])=>[key,null])]);
export function parseReferenceRows(text,fields){
 if(!text.trim())return [];
 const lines=text.replace(/\r/g,'').split('\n').filter(line=>line.trim());
 if(lines.length>10000)throw new Error('Maksimal 10.000 baris per daftar; tidak ada pemotongan data.');
 return lines.map((line,i)=>{
  const cells=line.split('\t').map(cell=>cell.trim());
  if(cells.length!==fields.length||cells.some(cell=>!cell))throw new Error(`Baris ${i+1}: isi ${fields.length} kolom sesuai urutan, dipisahkan tab.`);
  return Object.fromEntries(fields.map((field,index)=>[field,cells[index]]));
 });
}
export default function GLReferenceContext({value,onChange}){
 const [texts,setTexts]=useState(()=>Object.fromEntries(REGISTERS.map(([key,,fields])=>[key,(value?.[key]||[]).map(row=>fields.map(field=>row[field]).join('\t')).join('\n')])));
 const [errors,setErrors]=useState({});
 const changeText=(key,fields,text)=>{
  setTexts(v=>({...v,[key]:text}));
  try{const rows=parseReferenceRows(text,fields);setErrors(v=>({...v,[key]:null}));onChange({...value,[key]:rows},false,key);}
  catch(e){setErrors(v=>({...v,[key]:e.message}));onChange(value,true,key);}
 };
 return <details className="border rounded p-2 text-xs"><summary>Daftar referensi dan kalender fiskal</summary>
  <p>Gunakan daftar sumber yang benar-benar telah diperiksa. Daftar yang tidak tersedia tetap belum dinilai. Definisi ini dicatat bersama identitas penilai dan versi sumber GL.</p>
  <label><input type="checkbox" aria-label="Gunakan konteks referensi" checked={!!value} onChange={e=>{setErrors({});setTexts(Object.fromEntries(REGISTERS.map(([key])=>[key,''])));onChange(e.target.checked?empty():undefined,false,'all');}}/> Catat definisi referensi untuk penilaian ini</label>
  {value&&<div className="space-y-2">
   <label className="block">Asal daftar dan dasar penerapan<textarea aria-label="Asal daftar dan dasar penerapan" className="block border w-full" value={value.basis} onChange={e=>onChange({...value,basis:e.target.value})}/></label>
   {REGISTERS.map(([key,label,fields])=><div key={key}>
    <label><input aria-label={`${label} tersedia`} type="checkbox" checked={value[key]!==null} onChange={e=>{setErrors(v=>({...v,[key]:null}));setTexts(v=>({...v,[key]:''}));onChange({...value,[key]:e.target.checked?[]:null},false,key);}}/> {label} tersedia</label>
    {value[key]!==null&&<><p>Tempel baris dari spreadsheet tanpa judul kolom, dipisahkan tab. Urutan: {fields.join(' → ')}. Tanggal YYYY-MM-DD. Kosong berarti daftar terkonfirmasi tanpa baris.</p>
     <textarea aria-label={label} className="block border w-full font-mono" value={texts[key]} onChange={e=>changeText(key,fields,e.target.value)}/>
     {errors[key]&&<p role="alert">{errors[key]}</p>}</>}
   </div>)}
  </div>}
 </details>;
}
